export default "__VITE_ASSET__DIPGtTEO__"